export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12114.8731b3b5.jpg";